import { Directive, ElementRef, HostListener } from '@angular/core';
import { WindowRef } from '../../core/window.service';
import { NavigationEnd, Router } from "@angular/router";

@Directive({
    selector: '[myHideGlobalNav]'
})

export class HideGlobalNavDirective {

    didScroll: boolean;
    lastScrollTop: number = 0;
    delta: number = 5;

    navShown: boolean = true;

    constructor(private el: ElementRef, private winRef: WindowRef) {
        // run hasScrolled() and reset didScroll status
        setInterval(() => {
            if (this.didScroll) {
                this.hasScrolled();
                this.didScroll = false;
            }
        }, 250);
    }

    // on scroll, let the interval function know the user has scrolled
    @HostListener('window:scroll', ['$event']) hideNav(event) {
        this.didScroll = true;
    }

    private hasScrolled() {
        let st = this.winRef.nativeWindow.pageYOffset;

        //Check if they scrolled more than delta (or set scroll distance)
        if (Math.abs(this.lastScrollTop - st) <= this.delta) {
            return;
        }

        // If current position > last position AND scrolled past navbar...
        if (st > this.lastScrollTop && st > 80) {
            // Scroll Down
            this.navShown = false;
            this.el.nativeElement.classList.add('nav-up');
        } else {
            // Scroll Up
            if (st + this.winRef.nativeWindow.screen.height >= document.documentElement.clientHeight || st === 0) {
                this.navShown = true;
                this.el.nativeElement.classList.remove('nav-up');
            }
        }
        this.lastScrollTop = st;
    }
}
